<template>
	<div class="card-main">
		<figure class="item-icon">
			<img class="icon" :src="order.Icon" />
		</figure>
		<main v-if="order.OrderContents" class="card-info">
			<section v-for="item in order.OrderContents" class="info-box">
				<div class="title-line">
					<h1 class="title">{{ item.Titles[0] }}</h1>
					<div class="gap">
						<span class="line"></span
						><span class="tip" v-if="item.TitleTip">{{ item.TitleTip }}</span
						><span class="line"></span>
					</div>
					<h1 class="title">{{ item.Titles[1] }}</h1>
				</div>
				<p v-for="desc in item.Descriptions" class="info-desc one-line">
					{{ desc }}
				</p>
			</section>
		</main>
	</div>
</template>

<script>
export default {
	props: ["order"],
	data() {
		return {};
	},
	methods: {},
};
</script>

<style scoped>
figure,
h1,
p {
	margin: 0;
}

.card-main {
	display: flex;
}
.item-icon {
	flex-shrink: 0;
}
.item-icon .icon {
	display: block;
	width: 25px;
	height: 25px;
	margin-right: 10px;
	margin-top: 12px;
}

.card-info {
	flex: 1;
	min-width: 0;
}
.card-info .info-box .title-line {
	display: flex;
	align-items: center;
	min-height: 45px;
	margin-right: 8px;
}

.card-info .info-box .title-line .title {
	max-width: 45%;
	font-size: 16px;
	color: #333;
	font-weight: bold;
}

.title-line .gap {
	display: flex;
	align-items: center;
	margin: 0 3px;
}

.title-line .gap .tip {
	display: block;
	height: 15px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0px 8px;
	border-radius: 8px;
	background: #f1f1f1;
	font-size: 12px;
	color: #666666;
	white-space: nowrap;
}

.title-line .gap .line {
	display: block;
	width: 20px;
	height: 2px;
	transform: rotate(180deg);
	background: linear-gradient(90deg, #f1f1f1 0%, #ffffff 100%);
}

.title-line .gap .line:last-child {
	transform: rotate(0);
}

.card-info .info-box .info-desc {
	margin-bottom: 7px;
	font-size: 13px;
	color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/multiTrip.vue